import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
  templates: [],
  response: [],
  referenceNos: [],
  processData: [],
  allUserNames: [],
  seenStampData: [],
  isFetching: false,
  isSuccess: false,
  isUsersNameSuccess: false,
  isResponse: false,
  isAddResponse: false,
  isprocessData: false,
  isdataAdded: false,
  isError: false,
  errorMessage: '',
};

export const getPdfNewProcess = createAsyncThunk(
  'chd/pdfNewProcess',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.get(`/api/chd/pdfNewProcess?doc_id=${udata}`, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const AddMultyProcessDocument = createAsyncThunk(
  'api/chd/v2/addDocument',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.post('/api/chd/v2/addDocument', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const getTemplatesAsyn = createAsyncThunk(
  'document/getTemplates',
  async (udata = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;

      const response = await axios.get('/api/chd/templates', { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;

      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const AddMultipleProcessDocumentSlice = createSlice({
  name: 'Chdaddmultipleprocessdocument',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, { payload }) => {
      state.templates = [];
      state.response = [];
      state.processData = [];
      state.isprocessData = false;
      state.isError = false;
      state.isSuccess = false;
      state.isResponse = false;
      state.isAddResponse = false;
      state.errorMessage = '';
    },
    setAddState: (state, { payload }) => {
      state.isAddResponse = true;
      state.response = payload.data;
    },
    usetsetAddState: (state, { payload }) => {
      state.isAddResponse = false;
      state.isdataAdded = false;
    },
    setReferenceNoState: (state, { payload }) => {
      state.isResponse = true;
      state.referenceNos = payload.data.data;
      state.seenStampData = payload.data.template;
    },
    setResponseState: (state, { payload }) => {
      state.isResponse = true;
    },
    unSetResponseState: (state, { payload }) => {
      state.isResponse = false;
    },
    clearFetchProcessData: (state, { payload }) => {
      state.processData = [];
      state.isprocessData = false;
    },
    setUsersNameState: (state, { payload }) => {
      state.isUsersNameSuccess = true;
      state.allUserNames = payload.data.users;
    },
    clearUsersNameState: (state, { payload }) => {
      state.isUsersNameSuccess = false;
      state.allUserNames = [];
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {

    //get all data fetch ...

    [getPdfNewProcess.fulfilled]: (state, { payload }) => {
      // console.log(payload);
      state.processData = payload.data;
      state.isprocessData = true;
      state.isFetching = false;
      return state;
    },
    [getPdfNewProcess.pending]: (state) => {
      state.isFetching = true;
    },
    [getPdfNewProcess.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [AddMultyProcessDocument.fulfilled]: (state, { payload }) => {
      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.isdataAdded = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';
      return state;
    },
    [AddMultyProcessDocument.pending]: (state) => {
      state.isFetching = true;
    },
    [AddMultyProcessDocument.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [getTemplatesAsyn.fulfilled]: (state, { payload }) => {
      state.templates = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = payload.message;
      return state;
    },
    [getTemplatesAsyn.pending]: (state) => {
      state.isFetching = true;
    },
    [getTemplatesAsyn.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateSlice, setUsersNameState, clearUsersNameState, clearFetchProcessData, setResponseState, unSetResponseState, setAddState, usetsetAddState, setReferenceNoState } = AddMultipleProcessDocumentSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export function responseState() {

  return async (dispatch) => {
    dispatch(setResponseState());
  }
}

export function clearResponseState() {

  return async (dispatch) => {
    dispatch(unSetResponseState());
  }
}


export function clearFetchedProcessData() {

  return async (dispatch) => {
    dispatch(clearFetchProcessData());
  }
}

export function clearAddResponseState() {

  return async (dispatch) => {
    dispatch(usetsetAddState());
  }
}

export function clearAllUsersNameState() {

  return async (dispatch) => {
    dispatch(clearUsersNameState());
  }
}

export const adddmultipleprocesdocumentSelector = (state) => state.Chdaddmultipleprocessdocument;



export const getReferenceNoAsyn = () => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.get('/api/chd/referenceNumber', { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  // console.log('chd ref', data)
  dispatch(setReferenceNoState(data));
  return data;
};

export const getUsersNameAsyn = () => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.get('/api/chd/template/allUsers?limit=1000', { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  dispatch(setUsersNameState(data));
  return data;
};


export default AddMultipleProcessDocumentSlice.reducer;
